export default
    {
        listaTrabjadores: "/principal/listaTrabajadores",
        listaTrabjadoresCasf: "/principal/listaTrabajadoresCasf",
        borraEntrada:"/principal/borraEntrada",
    }
